export class EmployeeDevice {
  type: string;
  brand: string;
  model: string;
  operator: string;
}
